/*
 * Convert a number to a price using the Intl API
 */
var formatPrice = function formatPrice(price) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';

  if (price === 0) {
    return 'Free';
  }

  var formattedPrice = price;

  if (typeof Intl !== 'undefined') {
    var formatter = new Intl.NumberFormat('en-US', {
      currency: currency,
      style: 'currency',
      minimumFractionDigits: 2
    });
    formattedPrice = formatter.format(price);
  } else {
    formattedPrice = "$".concat(price);
  }

  return formattedPrice.split('.00').join('');
};

export default formatPrice;